import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "/vanguard-logo.png";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-[color:var(--border)] pt-24 pb-10 px-6 lg:px-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="ambient-glow-blue" style={{ bottom: -400, left: -200, opacity: 0.5 }} />
      <div className="mx-auto max-w-[1400px] relative">
        <div className="grid grid-cols-12 gap-y-16 lg:gap-x-12">
          <div className="col-span-12 lg:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--muted)] mb-6">
              Vanguard Water Systems
            </div>
            <div className="font-display text-[clamp(3rem,10vw,10rem)] font-black leading-[0.85] text-white">
              Vanguard<br />
              Water<br />
              <span className="text-[color:var(--blue)]">Systems.</span>
            </div>
            <p className="mt-8 max-w-md text-[color:var(--muted)] text-[15px] leading-relaxed font-body">
              Authorized Kinetico dealer proudly serving Northern Utah and Southern Idaho families for decades.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--muted)] mb-5">Site</div>
            <ul className="space-y-3 text-[14px] font-body">
              <li><Link to="/" className="link-underline hover:text-[color:var(--blue)]">Home</Link></li>
              <li><Link to="/products" className="link-underline hover:text-[color:var(--blue)]">Products</Link></li>
              <li><Link to="/services" className="link-underline hover:text-[color:var(--blue)]">Services</Link></li>
              <li><Link to="/about" className="link-underline hover:text-[color:var(--blue)]">About</Link></li>
              <li><Link to="/service-areas" className="link-underline hover:text-[color:var(--blue)]">Service Areas</Link></li>
              <li><Link to="/blog" className="link-underline hover:text-[color:var(--blue)]">Blog</Link></li>
              <li><Link to="/contact" className="link-underline hover:text-[color:var(--blue)]">Contact</Link></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--muted)] mb-5">Contact</div>
            <ul className="space-y-4 text-[14px] font-body">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-[color:var(--blue)]" />
                <a href="tel:+14357017171" className="link-underline" data-testid="footer-phone">(435) 701-7171</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-[color:var(--blue)]" />
                <a href="mailto:VanguardWaterSystems@gmail.com" className="link-underline break-all" data-testid="footer-email">
                  VanguardWaterSystems@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[color:var(--blue)]" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=180+N+100+E+Logan+UT+84321"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-underline"
                  data-testid="footer-address"
                >
                  180 N 100 E, Logan, UT 84321
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[color:var(--blue)]" />
                <span className="text-[color:var(--muted)]">Northern Utah · Southern Idaho</span>
              </li>
            </ul>
            <img src={LOGO_URL} alt="Vanguard Water Systems logo" className="mt-8 h-20 w-auto inline-block" />
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-[color:var(--border)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.3em] text-[color:var(--muted)]">
          <div>© {new Date().getFullYear()} Vanguard Water Systems · Authorized Kinetico Dealer</div>
          <div>Crafted with care in Utah</div>
        </div>
      </div>
    </footer>
  );
}
